import { useTranslation } from "react-i18next";
import { Badge, Box, Tabs } from "@mantine/core";

import { Container, LayoutStandard } from "components";
import { AuthorityConstants, ServiceConstants } from "constant";
import { displayClasses } from "styles";
import { AppUtils } from "utils";

import UserRecommendationCrmList from "./crm";
import UserRecommendationNewList from "./new";
import { useEffect, useState } from "react";
import { IRootState } from "config/redux";
import { useSelector } from "react-redux";
import { UserService } from "services";

const TABS = {
  NEW: "new",
  CRM: "crm",
}

const { REQUEST_USER_RECOMMENDATION_STATS_ID } = ServiceConstants;

const UserRecommendationListPage = () => {
  const { t } = useTranslation();
  const serviceObject = useSelector((state: IRootState) => state.service.object[REQUEST_USER_RECOMMENDATION_STATS_ID]);
  const [stats, setStats] = useState({
    'NEW': undefined,
    'IN_CRM': undefined
  });

  useEffect(() => {
    UserService.userRecommendationsStats();
  }, []);

  useEffect(() => {
    AppUtils.resolveServiceObject(serviceObject, REQUEST_USER_RECOMMENDATION_STATS_ID, setStats);
  }, [serviceObject]);

  return (
    <LayoutStandard
      authority={AuthorityConstants.ROLE_USR_REC}
      title={AppUtils.composeTabTitle(t('user.recommendation.list.title'))}
    >
      <Container>
        <Tabs defaultValue={TABS.NEW} keepMounted={false} variant={'pills'}>
          <Tabs.List>
            <Tabs.Tab value={TABS.NEW} className={displayClasses.tabList}>
              {t('user.recommendation.list.tab.' + TABS.NEW)}
              <BadgeNumber value={stats.NEW} />
              </Tabs.Tab>
            <Tabs.Tab value={TABS.CRM} className={displayClasses.tabList}>
              {t('user.recommendation.list.tab.' + TABS.CRM)}
              <BadgeNumber value={stats.IN_CRM} />
              </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value={TABS.NEW} className={displayClasses.tabContent}><UserRecommendationNewList /></Tabs.Panel>
          <Tabs.Panel value={TABS.CRM} className={displayClasses.tabContent}><UserRecommendationCrmList /></Tabs.Panel>
        </Tabs>
      </Container>
    </LayoutStandard>
  )
}

const BadgeNumber = ({ value }: { value: number | undefined }) => (
  value === undefined
    ? <></>
    : <Box style={{ marginLeft: 8, position: 'relative', bottom: 2, display: 'inline' }}>
        <Badge size={'sm'} bg={'none'} c={'gray'} style={{ borderColor: 'gray' }}>{value}</Badge>
      </Box>
)

export default UserRecommendationListPage;